import {
  AnimatedCheckMark,
  Button,
  Div,
  Flex,
  Input,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React from 'react'
import styles from './expenseOption.module.scss'
import { useEffectOnChange, useState } from 'src/hooks'

interface CustomExpenseOptionProps {
  onAdd: (amount: number) => void
  isSelected: boolean
  setExpenseAmount: (amount: number) => void
}

const CustomExpenseOption: React.FC<CustomExpenseOptionProps> = props => {
  const { onAdd, isSelected, setExpenseAmount } = props
  const [amount, setAmount] = useState(0)

  const handleChange = (val: string) => {
    setAmount(parseInt(val, 10))
  }

  useEffectOnChange(() => {
    if (isSelected) {
      setExpenseAmount(amount)
    }
  }, [amount])

  return (
    <Div className={`${styles.expenseOption} ${styles.customOption}`}>
      <Flex
        className={styles.customText}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Text type="subtitle">Expense</Text>
        <Text type="body">Select amount to add</Text>
      </Flex>
      <Div className={styles.customInput}>
        <Input
          onChange={val => handleChange(val)}
          type="number"
          value={amount.toString()}
          width={120}
          max={10000}
        />
      </Div>
      <Div className={styles.customTotal}>
        <Text type="subtitle">
          {isNaN(amount) ? '' : `$${amount.toFixed(2)}`}
        </Text>
      </Div>
      <Div className={styles.customAdd}>
        {isSelected ? (
          <Div cursor="pointer" onClick={() => onAdd(0)}>
            <AnimatedCheckMark filled={true} size="medium" />
          </Div>
        ) : (
          <Button size="small" onClick={() => onAdd(amount)}>
            Select
          </Button>
        )}
      </Div>
    </Div>
  )
}

export default CustomExpenseOption
